import React, { useCallback, useContext, useEffect } from "react";

import { Preview } from "@creatomate/preview";

import throttle from "lodash/throttle";
import styled from "styled-components";

import { DragContext } from "./context/DragContext";
import Draggable from "./Draggable";
import { usePreviewTime } from "../contexts/TimeContext";
import { useTimelineScale } from "../contexts/TimelineScaleContext";

const Main = styled.div`
  position: absolute;
  z-index: 40;
  top: 0;
  height: 100%;
  transform: translateX(-50%);
`;

const Head = styled.div`
  width: 14px;
  height: 24px;
  background: #3f4043;
  border-radius: 5px;
`;

const Line = styled.div`
  margin-left: 6px;
  width: 2px;
  height: calc(100% - 20px);
  background: #3f4043;
`;

interface PlayheadProps {
  preview: Preview;
}

const Playhead: React.FC<PlayheadProps> = ({ preview }) => {
  const { timelineScale } = useTimelineScale();
  const { time, setTime } = usePreviewTime();
  const { setDraggingElement, setIsDragging } = useContext(DragContext);

  useEffect(() => {
    setTime(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview]);

  const scrubToTime = (time: number) => {
    setTime(time);
    preview.setTime(time);
  };

  const throttledScrubToTime = useCallback(throttle(scrubToTime, 15), []);

  return (
    <Draggable
      onStart={(e, data) => ({ startX: data.x, startTime: time })}
      onDrag={(e, data, context) => {
        setDraggingElement(undefined);
        setIsDragging(true);
        const time = Math.max(context.startTime + (data.x - context.startX) / timelineScale, 0);
        throttledScrubToTime(time);
      }}
      onStop={() => {
        setIsDragging(false);
      }}
    >
      {(ref, _context) => (
        <Main
          onContextMenu={e => e.preventDefault()}
          ref={ref}
          style={{ left: time * timelineScale }}
        >
          <Head />
          <Line />
        </Main>
      )}
    </Draggable>
  );
};

export default Playhead;
